module.exports = __webpack_public_path__ + "img/Background5.9570d09c.jpg";